module.exports = __webpack_public_path__ + "static/img/logo11.b6716893.png";